import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faApple, faGooglePlay, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const WHATSAPP_URL = 'https://wa.me/436765551333';
const EMAIL = 'info@utkanesim.com';
const APP_STORE_URL = 'https://apps.apple.com/de/app/utkan-esim/id6748948123';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.utkan_esim_world';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const logo = process.env.PUBLIC_URL + '/logo.jpg';
  const year = new Date().getFullYear();

  return (
    <footer className="store-footer">
      <div className="store-footer-inner">
        <div className="store-footer-top">
          {/* Marka */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src={logo} alt="Utkan eSIM" />
              <span>Utkan eSIM</span>
            </Link>
            <p className="footer-tagline">{t('footer.tagline')}</p>

            <div className="footer-apps">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-badge"
                aria-label="App Store"
              >
                <FontAwesomeIcon icon={faApple} />
                <span>
                  <small>{t('apps.ios.label')}</small>
                  {t('apps.ios.name')}
                </span>
              </a>
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-badge"
                aria-label="Google Play"
              >
                <FontAwesomeIcon icon={faGooglePlay} />
                <span>
                  <small>{t('apps.android.label')}</small>
                  {t('apps.android.name')}
                </span>
              </a>
            </div>
          </div>

          {/* Bağlantı sütunları */}
          <nav className="footer-col" aria-label={t('footer.explore')}>
            <h4>{t('footer.explore')}</h4>
            <Link to="/">{t('footer.shop')}</Link>
            <Link to="/about">{t('nav.about')}</Link>
          </nav>

          <nav className="footer-col" aria-label={t('footer.support')}>
            <h4>{t('footer.support')}</h4>
            <Link to="/esim-guide">{t('nav.guide')}</Link>
            <Link to="/contact">{t('nav.contact')}</Link>
            <Link to="/contact">{t('footer.help')}</Link>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
          </nav>

          <nav className="footer-col" aria-label={t('footer.legal')}>
            <h4>{t('footer.legal')}</h4>
            <Link to="/privacy">{t('nav.privacy')}</Link>
            <Link to="/privacy">{t('footer.terms')}</Link>
            {/* Google Play, hesap silme yolunun uygulama dışından da
                bulunabilir olmasını istiyor — footer her sayfada görünür. */}
            <Link to={i18n.language?.startsWith('tr') ? '/hesap-sil' : '/account-deletion'}>
              {t('footer.deleteAccount')}
            </Link>
          </nav>
        </div>

        <div className="store-footer-bottom">
          <p className="footer-rights">{t('footer.rights', { year })}</p>
          <div className="footer-social">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            <a href={`mailto:${EMAIL}`} aria-label={t('contact.email.title')}>
              <FontAwesomeIcon icon={faEnvelope} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
